// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownH2Extended } from '../../../assets/icons/extended/markdown/markdown-h2.svg?react';
import { createIcons } from '../../Icon';
const MarkdownH2Icon = /* @__PURE__ */ createIcons('MarkdownH2', {
    extended: MarkdownH2Extended
});
MarkdownH2Icon.supportedTypes = ['extended'];
MarkdownH2Icon.category = 'markdown';
export default MarkdownH2Icon;
